goog.provide("shadow.js.shim.module$src$svg$controls$media_player_call$volume_slash_svg$default");
shadow.js.shim.module$src$svg$controls$media_player_call$volume_slash_svg$default = shadow.js.shim.module$src$svg$controls$media_player_call$volume_slash_svg.default;
